import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Items } from 'src/app/core/models/common/items.model';
import { STATUS_OPTIONS } from '../../../shared-constants';

@Component({
  selector: 'app-form-multiselect-dropdown',
  templateUrl: './form-multiselect-dropdown.component.html',
  styleUrls: ['./form-multiselect-dropdown.component.scss'],
  standalone: false,
})
export class FormMultiselectDropdownComponent {
  @Input() checkAllIds = true;
  @Input() searchResults: Items[] = [];
  @Input() dropdownWidth = '100';
  @Output() statusChangeEvent = new EventEmitter<boolean>();
  @Output() selectAllEvent = new EventEmitter<boolean>();
  readonly SELECT_ALL_TEXT = STATUS_OPTIONS.ALL_SELECTED;

  get dropdownWidthClass(): string | null {
    const width = Number(this.dropdownWidth);
    const allowedWidths = [60, 72, 100];
    return allowedWidths.includes(width)
      ? `multiselect-dropdown-width-${width}`
      : null;
  }

  statusChangeForDropdownEvent() {
    this.statusChangeEvent.emit(true);
  }
  selectAllCheckboxesEvent() {
    this.selectAllEvent.emit(this.checkAllIds);
  }
}
